(function () {
  function closeAllIn(section, exceptCard) {
    section.querySelectorAll('[data-reels-card].is-active').forEach(function (c) {
      if (c !== exceptCard) c.classList.remove('is-active');
    });
  }

  function initReelsSection(section) {
    if (section.dataset.reelsInit === 'true') return;
    section.dataset.reelsInit = 'true';

    var videos = section.querySelectorAll('[data-reels-video]');
    if (!videos.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            v.play().catch(function () {});
          } else {
            v.pause();
          }
        });
      },
      { threshold: 0.6 }
    );

    videos.forEach(function (v) {
      observer.observe(v);

      var card = v.closest('[data-reels-card]');
      var media = card ? card.querySelector('[data-reels-media]') : null;
      var btn = card ? card.querySelector('[data-reels-sound]') : null;

      if (media && !media.dataset.reelsTapBound) {
        media.dataset.reelsTapBound = 'true';
        media.addEventListener('click', function (e) {
          if (e.target.closest('[data-reels-sound]') || e.target.closest('.reels-shop')) return;
          var isActive = card.classList.contains('is-active');
          closeAllIn(section, card);
          card.classList.toggle('is-active', !isActive);
        });
      }

      if (!btn || btn.dataset.reelsBound === 'true') return;
      btn.dataset.reelsBound = 'true';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        v.muted = !v.muted;
        btn.classList.toggle('is-unmuted', !v.muted);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-reels-section]').forEach(initReelsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-reels-section]').forEach(initReelsSection);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-reels-media]')) return;
    document.querySelectorAll('[data-reels-card].is-active').forEach(function (c) {
      c.classList.remove('is-active');
    });
  });
})();
